import { sectors } from "@/mocks/gossip";

export default function Sectors() {
  return (
    <section className="bg-foreground-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-16">
        <div className="mb-8 flex flex-col justify-between gap-3 md:flex-row md:items-end">
          <div>
            <p className="mb-2 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-accent-400">
              <i className="ri-layout-grid-line" /> 栏目分区
            </p>
            <h2 className="font-heading text-2xl font-black tracking-tight text-background-50 md:text-3xl">按领域分流，追踪不串线</h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-background-100/70">
            每个领域独立收录新涉事者与背景线索，避免不同争议相互干扰。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {sectors.map((s, i) => (
            <a
              key={s.key}
              href="#faces"
              className="group flex flex-col rounded-lg border border-background-100/15 p-5 transition-colors hover:border-accent-400/60 hover:bg-background-100/5"
            >
              <span className="font-heading text-4xl font-black text-background-100/20 transition-colors group-hover:text-accent-400/70">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-3 font-heading text-lg font-bold text-background-50">{s.name}</h3>
              <span className="mt-1 inline-flex w-fit whitespace-nowrap rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] font-medium text-foreground-950">
                {s.count}
              </span>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-background-100/70">{s.blurb}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-accent-300 group-hover:text-accent-200">
                进入该分区 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}